/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsProductDetailViewProps } from '../../../modules/hosports-product-detail/./hosports-product-detail';
//@ts-ignore
import Callouts from './../../../baseComponents/product-detail/./callouts';
//@ts-ignore
import DetailImages from './../../../baseComponents/product-detail/./detail-images';
//@ts-ignore
import Hero from './../../../baseComponents/product-detail/./hero';
//@ts-ignore
//import Psa from './../../../baseComponents/product-detail/./psa';
//@ts-ignore
import Shaper from './../../../baseComponents/product-detail/./shaper';
//@ts-ignore
import TechFeatures from './../../../baseComponents/product-detail/./tech-features';
//@ts-ignore
import Specs from './../../../baseComponents/product-detail/./specs';
//@ts-ignore
import SpecTable from './../../../baseComponents/product-detail/./spec-table';
//@ts-ignore
import ProductList from './../../../baseComponents/product-list/./product-list';
//@ts-ignore
import VideoBox from './../../../baseComponents/video-box/./video-box';
//@ts-ignore
import Main from '../../../baseComponents/product-detail/./main';
//@ts-ignore
import WakesurfEdgeContent from '../../../baseComponents/product-detail/./wakesurf-edge-content';
//@ts-ignore
import ScrollFadeIn from '../../../baseComponents/scroll-fade/./scroll-fade';
// @ts-ignore
import {GetExternalProductInfo} from './../utilities/functions';
// @ts-ignore
import {GetLocalizedText,GetLocalizedPrice} from "./../utilities/functions";
// @ts-ignore
import {GetFromParse} from "./../utilities/parse";
// @ts-ignore
import {GetUrlVariable, GetUrlParamFromRoute} from './../utilities/helpers';
// @ts-ignore
import {ModelYear} from './../utilities/constants';

interface IState {
  product?:any;
  localizedContent?:any;
  video?:any;
  parentProduct?:any;
  category?:any;
  subcategory?:any;
}

class IHosportsProductDetail extends React.Component<IHosportsProductDetailViewProps> {
  public state: IState;

  constructor(props: IHosportsProductDetailViewProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount = async() => {
    let config = this.props.config;
    let slug = await GetUrlParamFromRoute('/product/');
    let product = await GetExternalProductInfo(slug,config.year);
    let category = await GetFromParse('Categories', product.attributes.category);
    let subcategory = await GetFromParse('Subcategories', product.attributes.subcategory);

    this.setState({
      product:product,
      category:category,
      subcategory:subcategory
    },async()=>{
      if(product && product.attributes){
        let content:any = {};
        let video:any = null;
        let config = this.props.config;
        content.tagline = await GetLocalizedText(product.attributes.content, "tagline",config.year);
        content.title = await GetLocalizedText(product.attributes.content, "title",config.year);
        content.description = await GetLocalizedText(product.attributes.content, "description",config.year);
        content.price = await GetLocalizedPrice(product.attributes.content, "price",config.year);
        video = product.attributes.video;
        let parentProduct = null;
        let year:any = config.year ? config.year : ModelYear;
        if(product.attributes.parentProducts && product.attributes.parentProducts[0]){
          parentProduct = await GetFromParse('Products'+year, product.attributes.parentProducts[0]);
          video = parentProduct.attributes.video;
        }
        this.setState({
          video:video,
          localizedContent:content,
          parentProduct:parentProduct
        })
      }
    })
  }
  public render(): JSX.Element {
    if(!this.state.product) return <span/>;
    let config = this.props.config;
    return (
      <div className='product-detail'>
        {this.state.product && this.state.product.attributes &&
          <>
            <ScrollFadeIn><Hero year={config.year} product={this.state.product} category={this.state.category} subcategory={this.state.subcategory} /></ScrollFadeIn>
            {this.state.localizedContent && <ScrollFadeIn><Main  year={config.year} localizedContent={this.state.localizedContent} product={this.state.product} parentProduct={this.state.parentProduct} /></ScrollFadeIn>}
            <ScrollFadeIn><DetailImages year={config.year} product={this.state.product} parentProduct={this.state.parentProduct} category={this.state.category} subcategory={this.state.subcategory} /></ScrollFadeIn>
            <ScrollFadeIn><Specs year={config.year} product={this.state.product} /></ScrollFadeIn>
            {this.state.video &&
              <ScrollFadeIn><VideoBox video={this.state.video} autoPlay muted fullWidth controls /></ScrollFadeIn>
            }
            {this.state.product.attributes.slug == 'booms-deluxe-gunnel-boom' &&
              <div className="row centered-text">
                <div className="small-12 medium-6 tiny-padding">
                  <div className="embed-container">
                    <VideoBox video={'https://www.youtube.com/watch?v=gGO8RlspNDk'} muted fullWidth controls />
                  </div>
                  <p>{'Testimonial'}</p>
                </div>
                <div className="small-12 medium-6 tiny-padding">
                  <div className="embed-container">
                    <VideoBox video={'https://www.youtube.com/watch?v=Xgzz3edIJtM'} muted fullWidth controls />
                  </div>
                  <p>{'Installation'}</p>
                </div>
              </div>
            }
            <ScrollFadeIn><WakesurfEdgeContent product={this.state.product} /></ScrollFadeIn>
            <ScrollFadeIn><div className="overflow-x-hidden"><TechFeatures  year={config.year} product={this.state.product} parentProduct={this.state.parentProduct} /></div></ScrollFadeIn>
            <ScrollFadeIn><SpecTable product={this.state.product} /></ScrollFadeIn>
            <ScrollFadeIn><Shaper product={this.state.product} parentProduct={this.state.parentProduct} /></ScrollFadeIn>
            {(this.state.product.attributes.relatedProducts && this.state.product.attributes.relatedProducts.length > 0) &&
              <div className="centered-text secondary-background medium-padding">
                <h4>{'Related Products'}</h4>
                <div className="max-width-container">
                  <ScrollFadeIn><ProductList alignment="centered" slugs={this.state.product.attributes.relatedProducts} /></ScrollFadeIn>
                </div>
              </div>
            }
            {/*
              <ScrollFadeIn><Psa product={this.state.product} /></ScrollFadeIn>
              <ScrollFadeIn><Callouts product={this.state.product} /></ScrollFadeIn>
            */}
          </>
        }
      </div>

    );
  }
}

export default IHosportsProductDetail;
